import { render, staticRenderFns } from "./scorecard-component.vue?vue&type=template&id=777898d0"
import script from "./scorecard-component.ts?vue&type=script&lang=ts&external"
export * from "./scorecard-component.ts?vue&type=script&lang=ts&external"
import style0 from "./scorecard.less?vue&type=style&index=0&lang=less&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('777898d0')) {
      api.createRecord('777898d0', component.options)
    } else {
      api.reload('777898d0', component.options)
    }
    module.hot.accept("./scorecard-component.vue?vue&type=template&id=777898d0", function () {
      api.rerender('777898d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/outage-clock/scorecard/scorecard-component.vue"
export default component.exports